<app-elevation-section>
<dx-data-grid #dxDataGrid
  [dataSource]="statusLogs"
  [rowAlternationEnabled]="true"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  noDataText="Velg en linje i timegridet for å se logg"
  keyExpr="Date">
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-paging [pageSize]="100"></dxo-paging>
    <!-- Dato -->
    <dxi-column dataField="DateDDMMYYYY" [caption]="languageService.LNG('Label.Date')"></dxi-column>
    <!-- Tidspunkt -->
    <dxi-column dataField="DateHHMM" [caption]="languageService.LNG('Label.Time')"></dxi-column>
    <!-- Endret av -->
    <dxi-column dataField="ByEmployeeName" [caption]="languageService.LNG('Label.UpdatedBy')"></dxi-column>
    <!-- Fra status -->
    <dxi-column dataField="OldStatusId" [caption]="languageService.LNG('Label.From.Status')" cellTemplate="fromStatusTemplate">
      <dxo-lookup [dataSource]="statuses" valueExpr="StatusId" displayExpr="Description"></dxo-lookup>
    </dxi-column>
    <!-- Til status -->
    <dxi-column dataField="StatusId" [caption]="languageService.LNG('Label.To.Status')" cellTemplate="toStatusTemplate">
        <dxo-lookup [dataSource]="statuses" valueExpr="StatusId" displayExpr="Description"></dxo-lookup>
    </dxi-column>
    <!-- Informert via -->
    <dxi-column [caption]="languageService.LNG('Informert via')">

    </dxi-column>
    <div *dxTemplate="let data of 'fromStatusTemplate'">
      <div [style]="getStatusStyleValue(data.value)">{{getStatusText(data.value)}}</div>
    </div>
    <div *dxTemplate="let data of 'toStatusTemplate'">
      <div [style]="getStatusStyleValue(data.value)">{{getStatusText(data.value)}}</div>
    </div>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let log of 'detail'">
      <div class="master-detail-caption">{{
        "Detaljer " 
      }}</div>
    <app-project-portal-log-detail-grid [key]="log.data.Date" [firstPreviousStatusId]="log.data.OldStatusId" [selectedTimeRecord]="selectedTimeRecord"></app-project-portal-log-detail-grid>
  </div>
    
</dx-data-grid>
</app-elevation-section>
